import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

export interface HttpError {
  status: number;
  message: string;
  url?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  key: string;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  setKey(k) {
    this.key = k;
  }

  get(url, options = {}) {
    options = this.setOptions(options);
    return this.http.get(url, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r, url));
  }

  rawGet(url, options: any = {}) {
    options = this.setOptions(options);
    options.responseType = 'blob'
    return this.http.get(url, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r, url));
  }

  post(url, body, options = {}) {
    options = this.setOptions(options);
    return this.http.post(url, body, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r, url));
  }

  uploadFiles(url, fileName, files, data=null, options = {}){
    options = this.setOptions(options,false);
    let formData = new FormData();
    files.forEach((file,i) => {
      formData.append(fileName[i], file, file.name);
    });
    if(data){
      formData.append('data', JSON.stringify(data));
    }
    return this.http.post(url, formData, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r, url));
  }

  delete(url, options = {}) {
    options = this.setOptions(options);
    return this.http.delete(url, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r, url));
  }

  put(url, body, options = {}) {
    options = this.setOptions(options);
    return this.http.put(url, body, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r, url));
  }

  patch(url, body, options = {}) {
    options = this.setOptions(options);
    return this.http.patch(url, body, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r, url));
  }

  private handleError(res: any, url?: string): never {
    const error: HttpError = {
      status: 0,
      message: 'Erro de conexão',
      url
    };

    if (res instanceof HttpErrorResponse) {
      error.status = res.status;
      error.message = res.statusText || `Erro HTTP ${res.status}`;
    } else if (typeof res === 'object' && res.status) {
      error.status = res.status;
      error.message = res.statusText || res.message || `Erro HTTP ${res.status}`;
    }

    throw error;
  }

  private handleResponse(res) {
    if (res.status === 401) {
      this.router.navigate(['/login']);
      const error: HttpError = { status: 401, message: 'Sessão expirada. Faça login novamente.' };
      throw error;
    }
    if (res.status >= 300) {
      const error: HttpError = { status: res.status, message: `Erro HTTP ${res.status}` };
      throw error;
    }
    return res.body;
  }

  private setOptions(options: any, contentType: any = 'application/json') {
    let header: HttpHeaders = new HttpHeaders();

    // Determine content type: priority to options.contentType, then parameter, then default
    const finalContentType = options.hasOwnProperty('contentType') ? options.contentType : contentType;

    if (finalContentType) {
      header = header.append('Content-Type', finalContentType);
    }

    if (this.key) {
      header = header.append("Authorization", "Bearer " + this.key);
    }

    // Remove contentType from options so it doesn't pollute the actual request options
    const { contentType: _, ...cleanOptions } = options;

    return Object.assign({ headers: header }, cleanOptions, { observe: 'response' });
  }
}
